export const SCRAPE_PATH_PREFIX = "/__scrape/";
export const SCRAPE_HOTELS_PATH = "/__scrape/hotels";

export const isScrapePath = (pathname: string) =>
  pathname.startsWith(SCRAPE_PATH_PREFIX);

// Access Dev's /api/v1/tokens rejects any member_key containing `:`, `.`, or `@`
// with a 400 (verified against the live provider). This id is sent verbatim as
// the Access `member_key`, so the separator MUST stay Access-safe — a `:` here
// silently breaks the entire scrape credential harvest (no token → no prices).
export const getScrapeUserId = (tenantId: string) => `scraper-${tenantId}`;
